<template>
  <v-row>
  <v-col cols="12" md="6">
  <v-card>
  <v-card-title>{{ $t('contacts.tags.title')}}</v-card-title>
  <v-card-text>
    <tag-selector v-if="item" :domain="item.id" v-model="tag"/>
  </v-card-text>
  </v-card>
  </v-col>
  <v-col cols="12" md="6">
  
  <transition name="slide-x-transition" mode="out-in">
  <router-view :key="$route.path"></router-view>
  </transition>
  
  <!--
    <router-view v-slot="{ Component, route }">
        <transition name="fade">
            <component :is="Component" :key="route.path" />
        </transition>
    </router-view>
  -->
  </v-col>
  </v-row>
</template>

<script>

import TagSelector from '@/components/TagSelector'
import { mapState } from 'vuex'

export default {
    name: 'Segments',
    components: { TagSelector },
    data() {
      return {
        tag: this.$route.params.segment
      }
    },
    computed: {
      ...mapState('domains', ['item'])
    },
    watch: {
      tag(val) {
        if(val) {
          console.debug('selected segment', val);
          this.$router.push({ name: 'segment', params: {segment: val }})
        } else {
          this.$router.push({ name: 'contacts' });
        }
      }
    }
}
</script>

<style>

</style>